export default {
  draft: {
    borderStyle: {
      paint: {
        borderColor: '#000000',
        borderOpacity: 1,
        borderWidth: 0
      },
      parsed: false
    },
    colorStyle: {
      custom: {
        topVariable: [],
        topN: [],
        colorBuckets: [],
        values: [],
        aggregationType: null,
        featureState: true,
        binCount: 5,
        color: '#51bbd6',
        colors: [],
        groupName: null,
        schemeType: 'sequential',
        revertColor: false,
        customMode: false,
        method: {
          value: 4,
          text: 'Quebra Natural (Heads/Tails)'
        },
        expression: null,
        expressionId: 0,
        metric: '',
        year: 0,
        statisticalType: [0, 1, 2, 3, 5]
      },
      paint: {
        circleBlur: 0,
        fillColor: '#51bbd6',
        fillOpacity: 1
      },
      parsed: false,
      applied: false
    },
    labelStyle: {
      custom: {
        aggregationType: null,
        expression: null,
        expressionId: 0,
        metric: '',
        year: 0
      },
      layout: {
        textAllowOverlap: false,
        backAllowOverlap: false,
        textSize: 12,
        textField: null,
        textAnchor: 'center',
        textVariableAnchor: ['center'],
        textOffset: [1, 0]
      },
      paint: {
        textColor: '#000000',
        textOpacity: 1,
        textHaloColor: '#FFFFFF',
        textHaloWidth: 1
      },
      parsed: false,
      applied: false
    },
    sizeStyle: {
      custom: {
        aggregationType: null,
        binCount: 5,
        method: {
          value: 4,
          text: 'Quebra Natural (Heads/Tails)'
        },
        expression: null,
        expressionId: 0,
        metric: '',
        year: 0,
        minToMax: true,
        size: [10, 50],
        featureState: true
      },
      paint: {
        iconSize: 1,
        circleRadius: 5,
        lineWith: 0.5,
      },
      parsed: false,
      applied: false
    },
    symbolStyle: {
      custom: {
        binCount: 5,
        topVariable: [],
        aggregationType: null,
        expression: null,
        expressionId: 0,
        metric: '',
        year: 0,
        symbols: [],
        symbolList: 'marker',
        symbolBuckets: []
      },
      layout: {
        iconAllowOverlap: true,
        iconImage: 'x-marker-15',
        iconSize: 1
      },
      paint: {
        iconColor: '#000000',
        iconHaloBlur: 0,
        iconHaloColor: 'rgba(0, 0, 0, 0)',
        iconHaloWidth: 0,
        iconOpacity: 1
      },
      parsed: false,
      applied: false
    }
  },
  markerStyle: {
    iconColor: '#00B8D4',
    iconImage: 'marker',
    iconSize: 1,
  },
}
